import React, { Component }  from 'react'
// import PropTypes from 'prop-types'
// import classnames from 'classnames'

export default class WebVR extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render() {
    return (
      <div className="webvr vr content">
        <div class="notes">
          {/*<h3>webvr projects</h3>*/}

          {/*<p>Most of these started live as a part of my threejs_starter project:*/}
            {/*<a href="https://github.com/JamesHagerman/threejs_starter">https://github.com/JamesHagerman/threejs_starter</a>*/}
          {/*</p>*/}

          {/*<ul>*/}
            {/*<li>*/}
              <a href="#whitebook">whitebook</a>: htc vive, crosslegged, center of play area.
              <a href="javascript:WHITEBOOK.onKey({keyCode: 74});">trigger(j)</a> to add,
              <a href="javascript:WHITEBOOK.onKey({keyCode: 75});">grips(k)</a> to remove
            {/*</li>*/}
            {/*<li><a href="#threads">Threads</a>: A WebVR project by myself and Natalie*/}
              {/*Sun (<a href="http://onattyso.com/">onattyso.com</a>). Not really Threads,*/}
              {/*but a tunnel-y offshoot of the same codebase.*/}
            {/*</li>*/}
            {/*<li><a href="#threejs">threejs</a>: Just a quick threejs test</li>*/}
            {/*<li><a href="#astrovr">AstrologyVR</a>: This was an unfinished project that uses NASA*/}
              {/*JPL's ephemeris to display planetery bodies in VR using a geocentric*/}
              {/*perspective for certain periods of time, specifically when people are*/}
              {/*born. It's broken for now...*/}
            {/*</li>*/}
          {/*</ul>*/}
        </div>

        <div class="scene"></div>

        <canvas id="floorcanvas"></canvas>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Projects/WebVR/index.js